import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  PLAYLIST_PANE,
  SEARCH_RESULTS_PANE,
  TRACK_PANE,
} from '@disco/constants/PaneTypes'
import styles from './index.module.css'

type Props = {
  error: Record<string, any>
  retry: (...args: Array<any>) => any
  pane: any
}
export default class Error extends Component<Props> {
  _handleRetry() {
    this.props.retry(this.props.pane)
  }

  render(): React.ReactElement<'div'> {
    let errorDescription = null
    const { pane, error } = this.props

    switch (error.status) {
      case 401:
      case 403:
        errorDescription = 'Your session has expired. Please login again.'
        break

      case 404:
        if (pane.type === PLAYLIST_PANE) {
          errorDescription = (
            <p>
              Sorry, this playlist doesn’t seem to be working right now. Someone
              might have saved a new version of the playlist or deleted it.
              Please click the library or channel you’re in to refresh.
            </p>
          )
        } else if (pane.type === TRACK_PANE) {
          errorDescription = (
            <p>
              Sorry, this track doesn’t seem to be loading right now. Someone
              might have deleted it. Please click the library or channel you’re
              in to refresh.
            </p>
          )
        } else if (pane.type === SEARCH_RESULTS_PANE && pane.groupId) {
          errorDescription = (
            <p>
              Sorry, this library or channel doesn’t seem to be loading right
              now. Someone might have deleted it. Please refresh your browser.
            </p>
          )
        } else {
          errorDescription = (
            <p>
              Sorry, something gone wrong. Our team has been notified and we’ll
              get it sorted very soon.
            </p>
          )
        }

        break

      case 504:
        let itemCaption = 'this item'

        if (pane.type === PLAYLIST_PANE) {
          itemCaption = 'this playlist'
        } else if (pane.type === TRACK_PANE) {
          itemCaption = 'this track'
        } else if (pane.type === SEARCH_RESULTS_PANE && pane.groupId) {
          itemCaption = 'this library or channel'
        } else if (pane.type === SEARCH_RESULTS_PANE && !pane.groupId) {
          itemCaption = 'search'
        }

        errorDescription = (
          <p>
            Sorry, {itemCaption} doesn’t seem to be working right now. Try
            clicking <b>Retry</b>. If that doesn’t work, let us know via the
            chat button at the bottom right of the app.
          </p>
        )
        break

      default:
        let defaultItemCaption = 'this item'

        if (pane.type === PLAYLIST_PANE) {
          defaultItemCaption = 'this playlist'
        } else if (pane.type === TRACK_PANE) {
          defaultItemCaption = 'this track'
        } else if (pane.type === SEARCH_RESULTS_PANE && pane.groupId) {
          defaultItemCaption = 'this library or channel'
        } else if (pane.type === SEARCH_RESULTS_PANE && !pane.groupId) {
          defaultItemCaption = 'search'
        }

        errorDescription = (
          <p>
            Sorry, {defaultItemCaption} doesn’t seem to be working right now.
            Our team has been notified and we’ll get it sorted very soon.
          </p>
        )
        break
    }

    let actionLink = null

    if (error.status === 403 || error.status === 401) {
      actionLink = (
        <Link className={styles.errorActionLink} to="/logout">
          Log in
        </Link>
      )
    } else if (error.status === 504) {
      actionLink = (
        <a
          className={styles.errorActionLink}
          onClick={() => this._handleRetry()}
        >
          Retry
        </a>
      )
    }

    return (
      <div className={styles.error}>
        <div className={styles.errorContent}>
          {errorDescription}
          {actionLink}
        </div>
      </div>
    )
  }
}
